import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes.js';
import store from '../store';

Vue.use(VueRouter);

// Interceptar e tratar navegação duplicada
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject);
    }
    return originalPush.call(this, location).catch(err => {
        if (VueRouter.isNavigationFailure(err, VueRouter.NavigationFailureType.duplicated)) {
            return err;
        }
        return Promise.reject(err);
    });
};

const router = new VueRouter({
    mode: 'history',
    linkExactActiveClass: 'active',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
});

router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.layout) {
        store.commit('setLayout', to.meta.layout);
    } else {
        store.commit('setLayout', 'app');
    }
    next();
});

router.afterEach((to, from) => {});

export default router;
